import './popupSignature.scss';

import React, { useContext, useImperativeHandle, useRef, useState } from 'react';
import { Popup, Button } from 'devextreme-react';
import { Position } from 'devextreme-react/popup';
import SignatureCanvas from 'react-signature-canvas';

type Props = {
    onSubmitDataURL: (dataURL: string) => void;
}

export type PopupSignatureHandle = {
    show: () => void
}

type State = {
    visible: boolean;
}

const PopupSignature: React.ForwardRefRenderFunction<PopupSignatureHandle, Props> = (props, ref) => {
    const [state, setState] = useState<State>({ visible: false });
    const signatureRef = useRef<SignatureCanvas>(null);

    useImperativeHandle(ref, () => ({
        show() {
            signatureRef.current?.clear();
            setState({ visible: true });
        }
    }));

    const clear = () => {
        signatureRef.current?.clear();
    }

    const submit = () => {
        var dataURL = signatureRef.current?.getTrimmedCanvas().toDataURL('image/png');
        if (dataURL) {
            props.onSubmitDataURL(dataURL);
            hideInfo();
        }
    }

    function hideInfo() {
        setState({ visible: false });
    }

    return (
        <React.Fragment>
            <Popup
                visible={state.visible}
                dragEnabled={true}
                hideOnOutsideClick={true}
                showCloseButton={true} onHidden={hideInfo}
                showTitle={true} title='Firma'
                fullScreen={false}
                container=".dx-viewport"
                height={430} width={750}
            >
                <Position at="center" my="center" of="" collision="fit" />

                <React.Fragment>
                    <SignatureCanvas ref={signatureRef} penColor='black' canvasProps={{ width: 700, height: 250, className: 'signatureCanvas' }} />

                    <div className='div-signature-buttons'>
                        <Button text='Pulisci' onClick={clear} />
                        <Button text='Conferma' onClick={submit} />
                    </div>
                </React.Fragment>
            </Popup>
        </React.Fragment>
    )
}

export default React.forwardRef(PopupSignature);